import type { FunctionComponent, JSX } from 'react';
import { Size } from '../../types';
import setDenaliAttribute from '../../utils/setDenaliAttribute';
import styles from './styles/styles.module.scss';

type IllustrationSize = Size<'xs' | 'sm' | 'md' | 'lg'>;

const illustrationSizeToPx: Record<IllustrationSize, number> = {
  xs: 48,
  sm: 96,
  md: 128,
  lg: 150
};

type IllustrationProps = {
  color?: string;
  size?: IllustrationSize;
};

export type IllustrationComponent = FunctionComponent<IllustrationProps>;

export default function Illustration(svgContents: JSX.Element): IllustrationComponent {
  function illustrationComponent({ color = 'var(--color-text-primary)', size = 'md' }: IllustrationProps) {
    const sizePx = `${illustrationSizeToPx[size]}px`;
    return (
      <svg
        {...setDenaliAttribute('Illustration')}
        className={styles.container}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 150 150"
        role="presentation"
        aria-hidden="true"
        focusable="false"
        style={{
          height: sizePx,
          width: sizePx,
          fill: color
        }}
      >
        {svgContents}
      </svg>
    );
  }

  return illustrationComponent;
}
